import React, { useState, useEffect } from 'react';
import { FaDownload } from "react-icons/fa";
import './AppDownloadOverlay.css';

const AppDownloadOverlay = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 7000);
    return () => clearTimeout(timer); 
  }, []); 

  const closeOverlay = () => {
    setIsVisible(false);
  };

  const handleDownload = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead', { 
        content_name: 'App Download Popup Special',
        content_category: 'Mobile App' 
      });
    }
    window.open("https://play.google.com/store/apps/details?id=com.astrobhagyap", "_blank");
    closeOverlay();
  };

  if (!isVisible) return null;

  return (
    <div className="ab-universe-wrapper">
      <div className="cosmic-nebula"></div>
      <div className="cosmic-stars"></div>
      
      <div className="shooting-star"></div>
      <div className="shooting-star"></div>
      <div className="shooting-star"></div>
      <div className="shooting-star"></div>

      <div className="ab-cosmic-card">
        <button className="ab-cosmic-close" onClick={closeOverlay} aria-label="Close">&times;</button>
        
        <div className="ab-cosmic-header">
           <div className="ab-logo-universe-box">
              <img 
                src={require("../../assets/AstrobhagyaLogoo.webp")} 
                alt="AstroBhagya Logo" 
                className="ab-main-universe-logo animated-logo" 
              />
              <img 
                src={require("../../assets/AstrobhagyaName.webp")} 
                alt="AstroBhagya Name" 
                className="ab-main-universe-name" 
              />
           </div>
        </div>

        {/* <div className="ab-cosmic-body">
         
            <h1 className="cosmic-title">Guidance is in the Stars</h1>
          
          <div className="valentine-offer-box">
          
            <h1 className="valentine-main-offer">START YOUR FIRST CHAT FOR FREE</h1>
          </div>

         <p className="cosmic-desc">
    Facing confusion in love, career, or marriage? Download the app and get a free 5 minute chat with real astrologers for clear guidance now.
  </p>
          
          <div className="ab-cosmic-spacer"></div>

          
          <div className="btn-container-center">
            <button className="ab-cosmic-btn" onClick={handleDownload}>
              <FaDownload className="cosmic-icon" />
              <span>DOWNLOAD NOW</span>
            </button>
          </div>
          
          <p className="ab-cosmic-subtext">Join our community of happy couples today</p>
        </div> */}
        <div className="ab-cosmic-body">
  {/* Stylish Title */}
  <h1 className="cosmic-title">Guidance is in the Stars</h1>
  
  {/* Screenshot wala Promo Box */}
  {/* <div className="valentine-offer-box">
    <h2 className="valentine-main-offer">GET UPTO 20% OFF WITH CODE</h2>
    <div className="promo-code-box">ASTRO20</div>
  </div> */}
  <div className="valentine-offer-box">
            <h2 className="valentine-main-offer">GET YOUR FIRST CHAT FOR FREE</h2>
          </div>

  {/* Screenshot wala Description */}
  {/* <p className="cosmic-desc">
    Facing confusion in love, career, or marriage? Download the app and use code <span style={{color: '#ff007f', fontWeight: 'bold'}}>ASTRO20</span> to get upto 20% off on your first session with real astrologers.
  </p> */}
  <p className="cosmic-desc">
            Facing confusion in love, career, or health? Download our app now and get a 
            <span style={{color: '#ff007f', fontWeight: 'bold'}}> FREE session </span> 
            with India's top astrologers for instant clarity.
          </p>
  
  <div className="ab-cosmic-spacer"></div>

  {/* Centered Download Button */}
  <div className="btn-container-center">
    <button className="ab-cosmic-btn" onClick={handleDownload}>
      <FaDownload className="cosmic-icon" />
      <span>DOWNLOAD NOW</span>
    </button>
  </div>
  
  <p className="ab-cosmic-subtext">Join our community of happy couples today</p>
</div>

        <div className="neon-border-line"></div>
      </div>
    </div>
  );
};

export default AppDownloadOverlay;